import { createSelector } from 'reselect';
const boxNotecardEditorRootSelector = state => state.boxNotecardEditor;
export const stepSelector = createSelector(boxNotecardEditorRootSelector, state => state.step);
export const boxNotecardColorSelector = createSelector(boxNotecardEditorRootSelector, state => state.color);
export const boxNotecardLogoPreviewSelector = createSelector(boxNotecardEditorRootSelector, state => {
  var _state$logo;
  return ((_state$logo = state.logo) === null || _state$logo === void 0 ? void 0 : _state$logo.originalPreview) || '';
});
export const isBoxNotecardLoadingSelector = createSelector(boxNotecardEditorRootSelector, state => state.isLogoLoading);
export const boxNotecardTextContentSelector = createSelector(boxNotecardEditorRootSelector, state => state.textContent);
export const selectedBoxItemsIdSelector = createSelector(boxNotecardEditorRootSelector, state => state.boxItemsId);
export const notecardDesignDataSelector = createSelector(boxNotecardEditorRootSelector, state => {
  const {
    defaultImage,
    textContent,
    color,
    logo
  } = state;
  return {
    defaultImage,
    textContent,
    color,
    logo
  };
});
export const isLoadingSelector = createSelector(boxNotecardEditorRootSelector, state => state.loading);